/** Formatação dos números da tela de custos. Uma casa só, porque os mesmos
 *  valores aparecem nos cartões do topo e nas linhas da tabela. */
export class Format {
  private static readonly CENTAVO = 0.01;

  /** Abaixo de US$ 1 o custo por chamada some com 2 casas — daí as 4. */
  static usd(value: number): string {
    return `$${value.toFixed(value < 1 ? 4 : 2)}`;
  }

  /** Duas casas é o real que se lê. Abaixo de dez centavos elas zeram o número —
   *  é o caso do custo por rodada —, então ali vão quatro. */
  private static readonly CENTAVOS_LEGIVEIS = 0.1;

  static brl(value: number): string {
    const casas = value > 0 && value < Format.CENTAVOS_LEGIVEIS ? 4 : 2;
    return `R$ ${value.toFixed(casas).replace('.', ',')}`;
  }

  static count(value: number): string {
    return value.toLocaleString('pt-BR');
  }

  /** "1 contato", "3 contatos". */
  static quantity(value: number, noun: { one: string; many: string }): string {
    return `${Format.count(value)} ${value === 1 ? noun.one : noun.many}`;
  }

  /** Faixa de gasto: o que não chega a um centavo vira "<$0,01" em vez de "$0.00",
   *  que se lê como ausência de custo. */
  static band(value: number): string {
    if (value >= Format.CENTAVO) return `$${value.toFixed(2)}`;
    if (value > 0) return '<$0,01';
    return '—';
  }

  private static readonly MILHAO = 1_000_000;
  private static readonly MIL = 10_000;

  /** Token se conta aos milhões: "11.493.825" ocupa a linha inteira e não se
   *  compara com o vizinho de olho. Abaixo de dez mil o número inteiro ainda se lê. */
  static tokens(value: number): string {
    if (value >= Format.MILHAO) return `${(value / Format.MILHAO).toFixed(1).replace('.', ',')}M`;
    if (value >= Format.MIL) return `${Math.round(value / 1000)}k`;
    return Format.count(value);
  }

  static percent(part: number, total: number, casas = 0): string {
    if (total <= 0) return '—';
    return `${((part / total) * 100).toFixed(casas).replace('.', ',')}%`;
  }
}
